import FalconCloseButton from "components/common/FalconCloseButton"
import { Button, Modal } from "react-bootstrap"




function DeleteModal({show, hide, deleteData}) {




    return (
        <>
            <Modal
                show={show}
                onHide={hide}
                // backdrop="static"
                keyboard={false}
            >
                <Modal.Header>
                    <Modal.Title className="text-danger"> Are you sure?</Modal.Title>
                    <FalconCloseButton onClick={hide} />
                </Modal.Header>
                <Modal.Body className="text-danger">This data will be deleted permanently.</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={hide}>
                        Close
                    </Button>
                    <Button variant="danger" onClick={deleteData}>Delete</Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default DeleteModal